// Píxeles de anuncios: Meta (Facebook) + Google Ads/GA4.
// Los IDs se leen de variables de entorno (build-time). Si faltan, no hace nada.
const META = process.env.REACT_APP_META_PIXEL_ID;
const GADS = process.env.REACT_APP_GOOGLE_ADS_ID; // "AW-XXXX" o "G-XXXX"
const GLABEL = process.env.REACT_APP_GOOGLE_ADS_CONVERSION_LABEL; // etiqueta de conversión (opcional)

let inited = false;

export function initAnalytics() {
  if (inited || typeof window === "undefined") return;
  inited = true;

  if (META) {
    /* eslint-disable */
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
      if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = "2.0"; n.queue = [];
      t = b.createElement(e); t.async = !0; t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
    })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
    /* eslint-enable */
    window.fbq("init", META);
    window.fbq("track", "PageView");
  }

  if (GADS) {
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${GADS}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag("js", new Date());
    window.gtag("config", GADS);
  }
}

export function trackPageView(path) {
  if (typeof window === "undefined") return;
  if (window.fbq) window.fbq("track", "PageView");
  if (window.gtag && GADS) window.gtag("event", "page_view", { page_path: path });
}

// Conversión de compra (checkout pagado)
export function trackPurchase({ value = 2900, currency = "EUR" } = {}) {
  if (typeof window === "undefined") return;
  if (window.fbq) window.fbq("track", "Purchase", { value, currency });
  if (window.gtag && GADS) {
    window.gtag("event", "conversion", {
      send_to: GLABEL ? `${GADS}/${GLABEL}` : GADS,
      value, currency,
    });
  }
}

// Lead (por ejemplo, iniciar checkout / contacto)
export function trackLead() {
  if (typeof window === "undefined") return;
  if (window.fbq) window.fbq("track", "Lead");
  if (window.gtag && GADS) window.gtag("event", "generate_lead");
}
